import React from 'react';
import { useSelector, shallowEqual } from 'umi';
import { IOrganizationPermissionProps } from './types';

// 需要隐藏内容的组织列表（内置配置）
export const HIDDEN_ORGANIZATIONS = ['Techland'];

/**
 * 组织权限容器组件
 * 根据用户所属组织判断是否显示内容
 * 如果用户的组织在内置的隐藏列表中（如Techland），则不显示children，否则显示children
 * 
 * @example
 * // 基础用法
 * <OrganizationPermission>
 *   <Button>仅非Techland组织可见</Button>
 * </OrganizationPermission>
 * 
 * @example
 * // 带回退内容
 * <OrganizationPermission 
 *   fallback={<div>您没有权限查看此内容</div>}
 * >
 *   <Button>受限内容</Button>
 * </OrganizationPermission>
 */
const OrganizationPermission: React.FC<IOrganizationPermissionProps> = ({
  children,
  fallback = null,
  additionalHideCondition = false,
}) => {
  const userInfo = useSelector(
    (state: any) => state.home.userInfo,
    shallowEqual,
  );

  // 获取用户的组织列表
  const userOrganizations: string[] = userInfo?.organization || [];

  // 判断用户是否属于需要隐藏的组织
  const shouldHide = userOrganizations.some((org: string) =>
    HIDDEN_ORGANIZATIONS.includes(org),
  );

  // 如果需要隐藏（组织匹配或外部传入的额外条件），返回 fallback 内容；否则返回 children
  if (shouldHide && !additionalHideCondition) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default OrganizationPermission;
export { OrganizationText } from './OrganizationText';
